module.exports = __webpack_public_path__ + "static/media/excel-plugin-resized.ef4d4dba.png";